import { render, staticRenderFns } from "./Poster.vue?vue&type=template&id=2a964cc7&scoped=true"
import script from "./Poster.vue?vue&type=script&lang=js"
export * from "./Poster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a964cc7",
  null
  
)

export default component.exports